module.exports = __webpack_public_path__ + "static/media/Sound_16368.2df2fe35.mp3";